import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {LibraryParams, LibraryType} from 'common/src/components/CLLibraries/CLLibraries.types';

interface LibrariesState {
  openLibraryType: LibraryType | null;
  params: LibraryParams;
}

const librariesInitialState: LibrariesState = {
  openLibraryType: null,
  params: {},
};

const librariesSlice = createSlice({
  name: 'libraries',
  initialState: librariesInitialState,
  reducers: {
    openLibrary: (
      state,
      action: PayloadAction<{libraryType: LibraryType; params?: LibraryParams}>,
    ) => {
      state.openLibraryType = action.payload.libraryType;
      state.params = action.payload.params ?? {};
    },
    closeLibrary: (state) => {
      state.openLibraryType = null;
      state.params = {};
    },
  },
});

export const {openLibrary, closeLibrary} = librariesSlice.actions;
export default librariesSlice.reducer;
